import React, { useEffect, useState } from "react";
import axios from "lib/api";
import { FormGroup, FormRow, Row, Textarea } from "styles/forms/main";
import {
    AccordionComponent,
    Input,
    SelectWithSearch,
    VerifyComponent,
    RejectionReason,
} from "components";
import { getUserRoles } from "modules/auth/slice";
import { useSelector } from "react-redux";
import { E_WALLETS, PAYMENT_METHOD } from "../staticData";
import EditHandler from "./EditHandler";

function PaymentMethods({
    driverData,
    handleDataFroSubmit,
    isEditable,
    errors,
    isEidtSection,
    objections,
    isAuthorizedToCreate,
    isQARole,
    handleObjections,
}) {
    const [banks, setBanks] = useState([]);
    const [mezzaBanks, setMezzaBanks] = useState([]);
    const [isOnEdit, setIsOnEdit] = useState(false);
    const [objection, setObjections] = useState({});

    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");

    const fetchBanks = () => {
        axios.get("/banks").then((res) => {
            setBanks(res.map((name) => ({ label: name })));
        });
    };
    const fetchMezzaBanks = () => {
        axios.get("/mezza_banks").then((res) => {
            setMezzaBanks(res.map((name) => ({ label: name })));
        });
    };
    useEffect(() => {
        fetchBanks();
        fetchMezzaBanks();
    }, []);

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };
    return (
        <AccordionComponent
            title="Payment Methods"
            defaultExpanded
            extraAction={
                isEidtSection && (
                    <EditHandler
                        isOnEdit={isOnEdit}
                        setIsOnEdit={setIsOnEdit}
                    />
                )
            }
            body={
                <div>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <SelectWithSearch
                                    label="Payment Method "
                                    placeholder="select"
                                    name="methodType"
                                    errorMsg={
                                        errors?.methodType !== "" && errors?.["methodType.label"]
                                    }
                                    error={
                                        errors?.methodType !== "" && errors?.["methodType.label"]
                                    }
                                    isEditable={isEditable || isOnEdit}
                                    isMulti={false}
                                    options={PAYMENT_METHOD}
                                    handleChange={(value) =>
                                        handleDataFroSubmit(value, "methodType")
                                    }
                                    value={driverData?.methodType}
                                />
                                {renderObjection("Payment Method")}
                                {getCurrentUserRole[0] === "reviewer" &&
                                    driverData?.methodType?.value !== undefined &&
                                    isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("methodType")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "methodType",
                                                    "Payment Method",
                                                    "Payments Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.methodType?.verified
                                                    ? objection?.methodType?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.methodType?.haveobjection
                                                    ? objection?.methodType?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                            </Row>
                            {objection?.methodType?.haveobjection && (
                                <Textarea
                                    autoFocus
                                    required
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Payment Method",
                                            "Payments Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                        {driverData?.methodType && (
                            <FormGroup>
                                <Row>
                                    <Input
                                        isEditable={isEditable || isOnEdit}
                                        label="Bank/ account owner name "
                                        errorMessage={errors?.accountHolderName}
                                        name="accountHolderName"
                                        type="text"
                                        required
                                        value={driverData?.accountHolderName}
                                        onChange={(e) => handleDataFroSubmit(e)}
                                        placeholder="Ex: Mohamed ahmed ali"
                                    />
                                    {renderObjection("Account Holder")}
                                    {getCurrentUserRole[0] === "reviewer" &&
                                        driverData?.methodType?.value !== undefined &&
                                        isQARole && (
                                            <VerifyComponent
                                                objectionHandler={() =>
                                                    openObjectionhandler("accountHolderName")
                                                }
                                                handleVerify={() =>
                                                    handleVerify(
                                                        "accountHolderName",
                                                        "Account Holder",
                                                        "Payments Info - Driver",
                                                        "driver_profile"
                                                    )
                                                }
                                                verifed={
                                                    objection?.accountHolderName?.verified
                                                        ? objection?.accountHolderName?.verified
                                                        : false
                                                }
                                                objection={
                                                    objection?.accountHolderName?.haveobjection
                                                        ? objection?.accountHolderName
                                                              ?.haveobjection
                                                        : false
                                                }
                                            />
                                        )}
                                </Row>
                                {objection?.accountHolderName?.haveobjection && (
                                    <Textarea
                                        autoFocus
                                        required
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Account Holder",
                                                "Payments Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        )}
                    </FormRow>
                    {driverData?.methodType?.value === "bank_account" && (
                        <>
                            <FormRow>
                                <FormGroup>
                                    <Row>
                                        <SelectWithSearch
                                            isEditable={isEditable || isOnEdit}
                                            errorMsg={errors?.bankName}
                                            error={errors?.bankName}
                                            isMulti={false}
                                            label="Bank Name"
                                            name="bankName"
                                            handleChange={(value) =>
                                                handleDataFroSubmit(value, "bankName")
                                            }
                                            options={banks}
                                            value={driverData?.bankName}
                                            placeholder="Select"
                                            required
                                        />
                                        {renderObjection("Bank Name")}
                                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                            <VerifyComponent
                                                objectionHandler={() =>
                                                    openObjectionhandler("bankName")
                                                }
                                                handleVerify={() =>
                                                    handleVerify(
                                                        "bankName",
                                                        "Bank Name",
                                                        "Payments Info - Driver",
                                                        "driver_profile"
                                                    )
                                                }
                                                verifed={
                                                    objection?.bankName?.verified
                                                        ? objection?.bankName?.verified
                                                        : false
                                                }
                                                objection={
                                                    objection?.bankName?.haveobjection
                                                        ? objection?.bankName?.haveobjection
                                                        : false
                                                }
                                            />
                                        )}
                                    </Row>
                                    {objection?.bankName?.haveobjection && (
                                        <Textarea
                                            required
                                            autoFocus
                                            onBlur={(e) =>
                                                handleObjections(
                                                    e,
                                                    "Bank Name",
                                                    "Payments Info - Driver",
                                                    "driver_profile",
                                                    false
                                                )
                                            }
                                        />
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Input
                                            isEditable={isEditable || isOnEdit}
                                            label="Bank Account Number"
                                            errorMessage={errors?.bankAccountNumber}
                                            name="bankAccountNumber"
                                            type="text"
                                            required
                                            value={driverData?.bankAccountNumber}
                                            onChange={(e) => handleDataFroSubmit(e)}
                                            placeholder="Ex: 0000000000000"
                                        />
                                        {renderObjection("Bank Account Number")}
                                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                            <VerifyComponent
                                                objectionHandler={() =>
                                                    openObjectionhandler("bankAccountNumber")
                                                }
                                                handleVerify={() =>
                                                    handleVerify(
                                                        "bankAccountNumber",
                                                        "Bank Account Number",
                                                        "Payments Info - Driver",
                                                        "driver_profile"
                                                    )
                                                }
                                                verifed={
                                                    objection?.bankAccountNumber?.verified
                                                        ? objection?.bankAccountNumber?.verified
                                                        : false
                                                }
                                                objection={
                                                    objection?.bankAccountNumber?.haveobjection
                                                        ? objection?.bankAccountNumber
                                                              ?.haveobjection
                                                        : false
                                                }
                                            />
                                        )}
                                    </Row>
                                    {objection?.bankAccountNumber?.haveobjection && (
                                        <Textarea
                                            required
                                            autoFocus
                                            onBlur={(e) =>
                                                handleObjections(
                                                    e,
                                                    "Bank Account Number",
                                                    "Payments Info - Driver",
                                                    "driver_profile",
                                                    false
                                                )
                                            }
                                        />
                                    )}
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <Row>
                                        <Input
                                            isEditable={isEditable || isOnEdit}
                                            label="IBAN Number"
                                            name="bankIban"
                                            errorMessage={errors?.bankIban}
                                            error={errors?.bankIban}
                                            type="text"
                                            required
                                            value={driverData?.bankIban}
                                            onChange={(e) => handleDataFroSubmit(e)}
                                            placeholder="Ex: 0000000000000"
                                        />
                                        {renderObjection("Bank IBAN Number")}
                                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                            <VerifyComponent
                                                objectionHandler={() =>
                                                    openObjectionhandler("bankIban")
                                                }
                                                handleVerify={() =>
                                                    handleVerify(
                                                        "bankIban",
                                                        "Bank IBAN Number",
                                                        "Payments Info - Driver",
                                                        "driver_profile"
                                                    )
                                                }
                                                verifed={
                                                    objection?.bankIban?.verified
                                                        ? objection?.bankIban?.verified
                                                        : false
                                                }
                                                objection={
                                                    objection?.bankIban?.haveobjection
                                                        ? objection?.bankIban?.haveobjection
                                                        : false
                                                }
                                            />
                                        )}
                                    </Row>
                                    {objection?.bankIban?.haveobjection && (
                                        <Textarea
                                            autoFocus
                                            required
                                            onBlur={(e) =>
                                                handleObjections(
                                                    e,
                                                    "Bank IBAN Number",
                                                    "Payments Info - Driver",
                                                    "driver_profile",
                                                    false
                                                )
                                            }
                                        />
                                    )}
                                </FormGroup>
                            </FormRow>
                        </>
                    )}
                    {driverData?.methodType?.value === "e_wallet" && (
                        <FormRow>
                            <FormGroup>
                                <Row>
                                    <SelectWithSearch
                                        isEditable={isEditable || isOnEdit}
                                        isMulti={false}
                                        label="E-Wallet Name"
                                        name="eWalletType"
                                        errorMsg={errors?.eWalletType}
                                        error={errors?.eWalletType}
                                        options={E_WALLETS}
                                        handleChange={(value) =>
                                            handleDataFroSubmit(value, "eWalletType")
                                        }
                                        value={driverData?.eWalletType}
                                        placeholder="Select"
                                        required
                                    />
                                    {renderObjection("Wallet Name")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("eWalletType")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "eWalletType",
                                                    "Wallet Name",
                                                    "Payments Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.eWalletType?.verified
                                                    ? objection?.eWalletType?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.eWalletType?.haveobjection
                                                    ? objection?.eWalletType?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.eWalletType?.haveobjection && (
                                    <Textarea
                                        autoFocus
                                        required
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Wallet Name",
                                                "Payments Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Input
                                        isEditable={isEditable || isOnEdit}
                                        label="E-wallet Number"
                                        name="eWalletNumber"
                                        errorMessage={errors?.eWalletNumber}
                                        type="text"
                                        required
                                        value={driverData?.eWalletNumber}
                                        onChange={(e) => handleDataFroSubmit(e)}
                                        placeholder="Ex: 0000000000000"
                                    />
                                    {renderObjection("Wallet Number")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("eWalletNumber")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "eWalletNumber",
                                                    "Wallet Number",
                                                    "Payments Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.eWalletNumber?.verified
                                                    ? objection?.eWalletNumber?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.eWalletNumber?.haveobjection
                                                    ? objection?.eWalletNumber?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.eWalletNumber?.haveobjection && (
                                    <Textarea
                                        required
                                        autoFocus
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Wallet Number",
                                                "Payments Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        </FormRow>
                    )}
                    {driverData?.methodType?.value === "mezza_card" && (
                        <FormRow>
                            <FormGroup>
                                <Row>
                                    <SelectWithSearch
                                        isEditable={isEditable || isOnEdit}
                                        isMulti={false}
                                        label="Meeza Card Bank Name"
                                        name="mezzaCardType"
                                        errorMsg={errors?.meezaCardName}
                                        error={errors?.meezaCardName}
                                        options={mezzaBanks}
                                        handleChange={(value) =>
                                            handleDataFroSubmit(value, "mezzaCardType")
                                        }
                                        value={driverData?.mezzaCardType}
                                        placeholder="Select"
                                        required
                                    />
                                    {renderObjection("Meza Card Bank Name")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("mezzaCardType")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "mezzaCardType",
                                                    "Meza Card Bank Name",
                                                    "Payments Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.mezzaCardType?.verified
                                                    ? objection?.mezzaCardType?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.mezzaCardType?.haveobjection
                                                    ? objection?.mezzaCardType?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.mezzaCardType?.haveobjection && (
                                    <Textarea
                                        autoFocus
                                        required
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Meza Card Bank Name",
                                                "Payments Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Input
                                        isEditable={isEditable || isOnEdit}
                                        label="Meeza Card Number"
                                        name="mezzaCardNumber"
                                        errorMessage={errors?.mezzaCardNumber}
                                        error={errors?.mezzaCardNumber}
                                        type="text"
                                        value={driverData?.mezzaCardNumber}
                                        onChange={(e) => handleDataFroSubmit(e)}
                                        required
                                        placeholder="Ex: 0000000000000"
                                    />
                                    {renderObjection("Meza Card Number")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("mezzaCardNumber")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "mezzaCardNumber",
                                                    "Meza Card Number",
                                                    "Payments Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.mezzaCardNumber?.verified
                                                    ? objection?.mezzaCardNumber?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.mezzaCardNumber?.haveobjection
                                                    ? objection?.mezzaCardNumber?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.mezzaCardNumber?.haveobjection && (
                                    <Textarea
                                        required
                                        autoFocus
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Meza Card Number",
                                                "Payments Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        </FormRow>
                    )}
                </div>
            }
        />
    );
}

export default PaymentMethods;
